module.exports = __webpack_public_path__ + "img/img25.1a959080.png";